export default __webpack_public_path__ + "static/media/CuciStep2-2.739ec0e1.png";